/*! Adapted from the theme's Bootstrap submenu fix v1.1, author web-master72. */
// Keyboard focus/ARIA synchronization remains in the theme's custom module.
function initializeSubmenus(): void {
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    function update(): void {
        const width = Math.max(jQuery(window).width() ?? 0, window.innerWidth);
        const items = jQuery('.menu-item-has-children').not('.mega-menu-col');
        items.children('.sub-menu, .mega-menu').css('margin-left', '0');

        if (width > 991) {
            items.removeClass('sub-menu-open');
        }

        items.off('mouseenter mouseleave');
        items.children('a').off('click');

        if (width > 991 && !mobile) {
            items.on({
                mouseenter() {
                    jQuery(this).addClass('sub-menu-open');
                },
                mouseleave() {
                    jQuery(this).removeClass('sub-menu-open');
                }
            });
            items.children('.sub-menu, .mega-menu').each(function () {
                const submenu = jQuery(this);
                const offset = submenu.offset();

                if (!offset) {
                    return;
                }

                const right = (submenu.width() ?? 0) + offset.left;

                if (right > width) {
                    submenu.css('margin-left', width - right - 30);
                }
            });
        } else {
            items.children('a').on('click', function (event) {
                event.preventDefault();
                const item = jQuery(this).parent();
                item.toggleClass('sub-menu-open');

                if (width > 991 && mobile) {
                    item.siblings().removeClass('sub-menu-open');
                    item.siblings().find('.sub-menu-open').removeClass('sub-menu-open');
                }
            });
        }
    }

    jQuery(window).on('resize', update);
    update();
}

if (document.readyState === 'complete') {
    initializeSubmenus();
} else {
    window.addEventListener('load', initializeSubmenus, { once: true });
}
